const StaticMap = {
  create: () => ({}),
  clear: (x) =>
    Object.keys(x).forEach((key) => {
      delete x[key]
    }),
}

export default StaticMap
